import { Routes } from '@angular/router';

export const paymentSubscriptionRoutes: Routes = [
  {
    path: '',
    redirectTo: 'failed-payment',
    pathMatch: 'full',
  },
  {
    // This route is used through email
    path: 'failed-payment',
    loadComponent: () => import('./failed-payment/failed-payment.component').then((m) => m.FailedPaymentComponent),
  },
  {
    path: 'failed-payment/schedule-consultation',
    loadComponent: () =>
      import('@shared/pages/schedule-consultation/schedule-consultation.page').then((m) => m.ScheduleConsultationPage),
  },
  {
    path: 'failed-payment/schedule-consultation/confirm',
    loadComponent: () =>
      import('@shared/pages/schedule-confirmation/schedule-confirmation.page').then((m) => m.ScheduleConfirmationPage),
  },
  {
    path: 'confirmation',
    loadComponent: () =>
      import('./payment-confirmation/payment-confirmation.component').then((m) => m.PaymentConfirmationComponent),
  },
];
